/* ongod — Zipper intro (2a Black jersey · Auto). Paired with snippets/og-zipper-intro.liquid */
(function () {
  'use strict';
  var root = document.getElementById('og-zip'), html = document.documentElement;
  if (!root) return;
  if (html.classList.contains('og-zip-off')) { root.parentNode.removeChild(root); return; }
  root.setAttribute('data-run', '1'); clearTimeout(window.__ogZipT);
  try { localStorage.setItem('og_zip_seen', '1'); } catch (e) {}

  var cv = root.querySelector('canvas'), charm = root.querySelector('.og-zip__charm'), pull = root.querySelector('.og-zip__pull'),
    shine = root.querySelector('.og-zip__shine'), skipBtn = root.querySelector('.og-zip__skip'), imgs = root.querySelectorAll('img');
  var K = { L: 15, T: 4.8, P: 6.4, OV: 1.5, TW: 8, CX: 89.4, CH: 162 };
  var F = { base: '#0E0E0F', tape: '#19191B', stitch: 'rgba(255,255,255,.2)', hi: 'rgba(255,255,255,.085)', lo: 'rgba(0,0,0,.42)', drop: 'rgba(0,0,0,.6)', fold: 'rgba(0,0,0,.75)' };
  var ctx, W, H, dpr, cx, s0, fabImg, tooth, wr, raf, done = false, ready = 0;
  var st = { s: 0, th: 9, w: 0, spread: 0, om: 0, alpha: 1, tw: null, phase: 'wait', t0: performance.now(), last: 0, tOut: 0 };

  function rr(x, X, Y, w, h, r) { x.beginPath(); x.moveTo(X + r, Y); x.arcTo(X + w, Y, X + w, Y + h, r); x.arcTo(X + w, Y + h, X, Y + h, r); x.arcTo(X, Y + h, X, Y, r); x.arcTo(X, Y, X + w, Y, r); x.closePath(); }
  function ease(n, k) {
    if (n === 'out') return 1 - Math.pow(1 - k, 3);
    return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
  }
  function tween(from, to, dur, e) { st.tw = { from: from, to: to, dur: dur, ease: e, t0: performance.now() }; }
  function sEnd() { return H + K.CH + 24; }

  function makeFabric() {
    var c = document.createElement('canvas'); c.width = Math.round(W * dpr); c.height = Math.round(H * dpr);
    var x = c.getContext('2d'); x.scale(dpr, dpr);
    x.fillStyle = F.base; x.fillRect(0, 0, W, H);
    var cw = 3.4, rh = 2.9, G = [new Path2D(), new Path2D(), new Path2D()], y, X;
    for (y = -rh; y < H + rh; y += rh) for (X = 0; X < W + cw; X += cw) {
      var g = G[(Math.random() * 3) | 0];
      g.moveTo(X + 0.55, y); g.lineTo(X + cw / 2, y + rh * 1.08); g.moveTo(X + cw - 0.55, y); g.lineTo(X + cw / 2, y + rh * 1.08);
    }
    x.lineCap = 'round'; x.lineWidth = 1.05;
    ['rgba(255,255,255,.06)', 'rgba(255,255,255,.09)', 'rgba(255,255,255,.04)'].forEach(function (s, i) { x.strokeStyle = s; x.stroke(G[i]); });
    x.fillStyle = 'rgba(0,0,0,.4)'; for (X = 0; X < W + cw; X += cw) x.fillRect(X - 0.25, 0, 0.5, H);
    var id = x.getImageData(0, 0, c.width, c.height), d = id.data;
    for (var i = 0; i < d.length; i += 4) { var n = (Math.random() - 0.5) * 9; d[i] += n; d[i + 1] += n; d[i + 2] += n; }
    x.putImageData(id, 0, 0);
    var lt = 'rgba(255,255,255,.055)', dk = 'rgba(0,0,0,.42)';
    function band(p, w, col, bl) {
      x.save(); x.shadowColor = col; x.shadowBlur = bl * dpr; x.shadowOffsetX = 10000 * dpr; x.lineCap = 'round'; x.lineWidth = w; x.strokeStyle = '#000';
      x.beginPath(); x.moveTo(p[0] * W - 10000, p[1] * H); x.bezierCurveTo(p[2] * W - 10000, p[3] * H, p[4] * W - 10000, p[5] * H, p[6] * W - 10000, p[7] * H); x.stroke(); x.restore();
    }
    [[.16, -.05, .2, .35, .12, .7, .18, 1.05, 70], [.37, -.05, .34, .4, .4, .7, .35, 1.05, 46], [.66, -.05, .7, .38, .62, .72, .67, 1.05, 52], [.88, -.05, .84, .4, .9, .7, .86, 1.05, 80]].forEach(function (b) { band(b, b[8], lt, 42); });
    [[.27, -.05, .25, .4, .3, .7, .26, 1.05, 34], [.78, -.05, .8, .35, .75, .7, .79, 1.05, 30], [.05, .5, .08, .7, .04, .9, .07, 1.05, 50], [.95, .45, .93, .7, .97, .9, .94, 1.05, 50]].forEach(function (b) { band(b, b[8], dk, 38); });
    band([-.05, .05, .12, .12, .3, .22, .44, .34], 26, dk, 30); band([1.05, .07, .88, .13, .7, .22, .56, .33], 26, dk, 30);
    band([-.02, .02, .12, .07, .26, .14, .4, .24], 14, lt, 20); band([1.02, .04, .88, .09, .74, .15, .6, .24], 14, lt, 20);
    var lg = x.createRadialGradient(W / 2, -H * 0.25, 0, W / 2, -H * 0.25, H * 1.35);
    lg.addColorStop(0, F.hi); lg.addColorStop(0.55, 'rgba(0,0,0,0)'); lg.addColorStop(1, F.lo);
    x.fillStyle = lg; x.fillRect(0, 0, W, H);
    return c;
  }
  function makeTooth() {
    var L = K.L, T = K.T, pad = 3, c = document.createElement('canvas');
    c.width = Math.ceil((L + pad * 2) * dpr); c.height = Math.ceil((T + pad * 2) * dpr);
    var x = c.getContext('2d'); x.scale(dpr, dpr); x.translate(pad, pad);
    var g = x.createLinearGradient(0, 0, 0, T);
    g.addColorStop(0, '#ECECE7'); g.addColorStop(0.25, '#C4C4BE'); g.addColorStop(0.62, '#87877F'); g.addColorStop(1, '#4A4A46');
    x.save(); x.shadowColor = 'rgba(0,0,0,.55)'; x.shadowBlur = 2 * dpr; x.shadowOffsetY = 0.9 * dpr;
    rr(x, 0, 0, L, T, 2.1); x.fillStyle = g; x.fill(); x.restore();
    x.lineWidth = 0.55; x.strokeStyle = 'rgba(0,0,0,.5)'; rr(x, 0, 0, L, T, 2.1); x.stroke();
    var g2 = x.createLinearGradient(0, 0, 5, 0); g2.addColorStop(0, 'rgba(0,0,0,.45)'); g2.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g2; rr(x, 0, 0, 5, T, 2); x.fill();
    x.fillStyle = 'rgba(0,0,0,.3)'; rr(x, L - 4.6, T * 0.3, 2.6, T * 0.4, 0.9); x.fill();
    x.fillStyle = 'rgba(255,255,255,.65)'; x.fillRect(3.5, 0.8, L - 8, 0.6);
    return { c: c, w: L + pad * 2, h: T + pad * 2, pad: pad };
  }
  function makeWrinkle() {
    var w = 44, h = 18, c = document.createElement('canvas'); c.width = Math.ceil(w * dpr); c.height = Math.ceil(h * dpr);
    var x = c.getContext('2d'); x.scale(dpr, dpr);
    function s(col, dy, lw, bl) {
      x.save(); x.shadowColor = col; x.shadowBlur = bl * dpr; x.shadowOffsetX = 1000 * dpr; x.lineCap = 'round'; x.lineWidth = lw; x.strokeStyle = '#000';
      x.beginPath(); x.moveTo(3 - 1000, 5 + dy); x.quadraticCurveTo(18 - 1000, 6 + dy, 38 - 1000, 13 + dy); x.stroke(); x.restore();
    }
    s('rgba(255,255,255,.08)', -2.2, 2, 2.5); s('rgba(0,0,0,.65)', 0, 2.6, 3.2);
    return { c: c, w: w, h: h };
  }

  function resize() {
    var nW = window.innerWidth, nH = window.innerHeight, nd = Math.min(window.devicePixelRatio || 1, 2.5);
    if (fabImg && nW === W && Math.abs(nH - H) < 80 && nd === dpr) { H = nH; return; }
    W = nW; H = nH; dpr = nd;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); ctx = cv.getContext('2d');
    fabImg = makeFabric(); tooth = makeTooth(); wr = makeWrinkle();
    cx = W / 2; s0 = Math.max(64, Math.round(H * 0.11));
    if (st.phase === 'wait' || st.phase === 'hold') st.s = s0;
  }

  function draw() {
    var L = K.L, T = K.T, P = K.P, OV = K.OV, TW = K.TW, k, q, b;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
    var a = st.s + 12, top = -60, len = a - top, M = 40, C = [];
    var o = 6 + Math.max(0, a - s0 - 12) * 0.42 + Math.max(0, a - H * 0.72) * 1.1 + st.om;
    for (k = 0; k <= M; k++) { q = k / M; C.push([cx - o * Math.pow(q, 1.3), a - len * q]); }
    var arc = 0;
    for (k = 0; k <= M; k++) {
      var p0 = C[Math.max(0, k - 1)], p1 = C[Math.min(M, k + 1)], tx = p0[0] - p1[0], ty = p0[1] - p1[1], tl = Math.hypot(tx, ty) || 1;
      tx /= tl; ty /= tl; if (k > 0) arc += Math.hypot(C[k][0] - C[k - 1][0], C[k][1] - C[k - 1][1]);
      C[k].push(ty, -tx, arc);
    }
    function off(k, d) { return [C[k][0] - C[k][2] * d, C[k][1] - C[k][3] * d]; }
    function lineAt(d) { var p = new Path2D(); p.moveTo(cx - d, H + 60); for (var k = 0; k <= M; k++) { var b = off(k, d); p.lineTo(b[0], b[1]); } return p; }
    var FB = L - 3 + TW / 2, poly = new Path2D(), bM = off(M, FB);
    poly.moveTo(-4000, top - 80); poly.lineTo(bM[0], top - 80);
    for (k = M; k >= 0; k--) { b = off(k, FB); poly.lineTo(b[0], b[1]); }
    poly.lineTo(cx, a + 18); poly.lineTo(cx, H + 120); poly.lineTo(-4000, H + 120); poly.closePath();
    function side(m, fn) { ctx.save(); if (m) { ctx.translate(2 * cx, 0); ctx.scale(-1, 1); } ctx.translate(-st.spread, 0); ctx.globalAlpha = st.alpha; fn(m); ctx.restore(); }
    var total = C[M][4], str = total / len, ox = -L + OV - tooth.pad, oy = -T / 2 - tooth.pad;
    function at(u) {
      if (u >= a) return [cx, u, 1, 0];
      var d = (a - u) * str, k = 1; while (k < M && C[k][4] < d) k++;
      var A = C[k - 1], B = C[k], q = Math.min(1.5, (d - A[4]) / ((B[4] - A[4]) || 1));
      return [A[0] + (B[0] - A[0]) * q, A[1] + (B[1] - A[1]) * q, A[2] + (B[2] - A[2]) * q, A[3] + (B[3] - A[3]) * q];
    }
    [0, 1].forEach(function (m) { side(m, function () { ctx.shadowColor = F.drop; ctx.shadowBlur = 24 * dpr; ctx.shadowOffsetY = 6 * dpr; ctx.fillStyle = F.base; ctx.fill(poly); }); });
    [0, 1].forEach(function (m) {
      ctx.save(); if (m) { ctx.translate(2 * cx, 0); ctx.scale(-1, 1); } ctx.translate(-st.spread, 0); ctx.clip(poly);
      ctx.setTransform(dpr, 0, 0, dpr, (m ? st.spread : -st.spread) * dpr, 0); ctx.globalAlpha = st.alpha; ctx.drawImage(fabImg, 0, 0, W, H); ctx.restore();
    });
    var open = Math.min(1, Math.max(0, (a - s0 - 12) / 260));
    [0, 1].forEach(function (m) {
      side(m, function (m) {
        ctx.save(); ctx.clip(poly);
        for (var u = top + 9 + (m ? 13 : 0); u < H + 20; u += 26) {
          var p = at(u); if (p[1] < -30) continue;
          ctx.save(); ctx.translate(p[0] - p[2] * (FB + 2), p[1] - p[3] * (FB + 2)); ctx.rotate(Math.atan2(-p[3], -p[2])); ctx.scale(1, -1);
          ctx.drawImage(wr.c, -3, -5, wr.w, wr.h); ctx.restore();
        }
        ctx.restore();
        if (open > 0.01) {
          ctx.save(); ctx.clip(poly); ctx.globalAlpha = st.alpha * open; ctx.shadowColor = F.fold; ctx.shadowBlur = 30 * dpr;
          ctx.lineWidth = 24; ctx.strokeStyle = '#000'; var fp = new Path2D();
          for (var k2 = 0; k2 <= M; k2++) { var b2 = off(k2, FB - 14); if (k2) fp.lineTo(b2[0], b2[1]); else fp.moveTo(b2[0], b2[1]); }
          ctx.stroke(fp); ctx.restore();
        }
      });
    });
    [0, 1].forEach(function (m) {
      side(m, function () {
        ctx.lineJoin = 'round';
        ctx.lineWidth = TW; ctx.strokeStyle = F.tape; ctx.stroke(lineAt(FB));
        ctx.lineWidth = 0.6; ctx.strokeStyle = 'rgba(0,0,0,.35)'; ctx.stroke(lineAt(FB - TW / 2 + 0.4));
        ctx.lineWidth = 0.8; ctx.strokeStyle = F.stitch; ctx.setLineDash([2.2, 2.4]); ctx.stroke(lineAt(FB + TW / 2 - 1.7)); ctx.setLineDash([]);
      });
    });
    [0, 1].forEach(function (m) {
      side(m, function () {
        for (var u = top + (m ? P / 2 : 0); u < H + 20; u += P) {
          if (u >= a) { ctx.drawImage(tooth.c, cx + ox, u + oy, tooth.w, tooth.h); continue; }
          var p = at(u); if (p[1] < -20) continue;
          ctx.save(); ctx.translate(p[0], p[1]); ctx.rotate(Math.atan2(p[3], p[2])); ctx.drawImage(tooth.c, ox, oy, tooth.w, tooth.h); ctx.restore();
        }
      });
    });
  }

  function doShine() { if (shine && shine.animate) shine.animate([{ backgroundPosition: '130% 0' }, { backgroundPosition: '-30% 0' }], { duration: 1300, easing: 'cubic-bezier(.4,0,.2,1)' }); }
  function finish() {
    if (done) return; done = true; cancelAnimationFrame(raf);
    window.removeEventListener('resize', resize); html.classList.remove('og-zip-on');
    if (root.parentNode) root.parentNode.removeChild(root);
  }
  function skip() { if (st.phase === 'run' || st.phase === 'out') return; tween(st.s, sEnd(), 700, 'inOut'); st.phase = 'run'; }

  function tick(now) {
    if (done) return;
    try {
      var dt = st.last ? Math.min(50, now - st.last) : 16.7, f = dt / 16.67; st.last = now;
      if (st.phase === 'wait' && ((ready >= imgs.length && now - st.t0 > 250) || now - st.t0 > 2500)) { st.phase = 'hold'; st.t0 = now; doShine(); }
      if (st.phase === 'hold' && now - st.t0 > 950) { tween(st.s, sEnd(), 1850, 'inOut'); st.phase = 'run'; }
      if (st.tw) {
        var k = Math.min(1, (now - st.tw.t0) / st.tw.dur);
        st.s = st.tw.from + (st.tw.to - st.tw.from) * ease(st.tw.ease, k);
        if (k >= 1) { st.tw = null; if (st.phase === 'run') { st.phase = 'out'; st.tOut = now; } }
      }
      if (st.phase === 'out') {
        var ko = Math.min(1, (now - st.tOut) / 560);
        st.spread = W * 0.7 * ko * ko * ko; st.om = W * 1.4 * ko * ko; st.alpha = ko < 0.3 ? 1 : 1 - ease('out', (ko - 0.3) / 0.7);
        if (ko >= 1) { finish(); return; }
      }
      var tgt = st.phase === 'run' ? 3 : 0;
      st.w += (-(st.th - tgt) * 0.085 - st.w * 0.11) * f; st.th = Math.max(-11, Math.min(11, st.th + st.w * f));
      draw();
      if (root.style.background !== 'transparent') root.style.background = 'transparent';
      charm.style.transform = 'translate3d(' + (cx - K.CX) + 'px,' + st.s + 'px,0)'; charm.style.opacity = st.alpha;
      pull.style.transform = 'rotate(' + st.th + 'deg)';
      if (st.phase === 'out') skipBtn.style.opacity = st.alpha;
    } catch (e) { finish(); return; }
    raf = requestAnimationFrame(tick);
  }

  try { resize(); st.s = s0; } catch (e) { finish(); return; }
  Array.prototype.forEach.call(imgs, function (img) {
    if (img.complete) ready++; else { img.addEventListener('load', function () { ready++; }); img.addEventListener('error', function () { ready++; }); }
  });
  skipBtn.addEventListener('click', skip);
  window.addEventListener('resize', resize);
  setTimeout(finish, 9000);
  raf = requestAnimationFrame(tick);
})();
